import { render, staticRenderFns } from "./departmentPersonnel.vue?vue&type=template&id=a2105d6a&"
import script from "./departmentPersonnel.vue?vue&type=script&lang=js&"
export * from "./departmentPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports